import { ContentWrapper } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { useWindowSize } from '@/hooks';
import { Descriptions, Tooltip } from 'antd';
import { FcInfo } from 'react-icons/fc';

interface Props {
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipHeader({ bankAccount }: Props) {
  const { isMobile } = useWindowSize();

  return (
    <ContentWrapper style={{ padding: '10px' }}>
      <Descriptions
        column={{ xs: 1, sm: 2, md: 3, xl: 4 }}
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {bankAccount?.bank.name}

            <Tooltip
              trigger="click"
              title="Informações do banco, são informações fornecidas na aba de detalhes da conta bancária"
              placement="top"
            >
              <FcInfo size={20} id="note-type-icon" cursor={'pointer'} />
            </Tooltip>
          </div>
        }
        layout={isMobile ? 'vertical' : 'horizontal'}
        className="workorder-descriptions"
        style={{ marginBottom: 24 }}
      >
        <Descriptions.Item label="Código do Banco">
          {bankAccount?.bank.code}
        </Descriptions.Item>

        <Descriptions.Item label="Agência">
          {`${bankAccount?.bankBranch} - ${
            bankAccount?.branchVerificationNumber ?? ''
          }`}
        </Descriptions.Item>

        <Descriptions.Item label="Número">
          {`${bankAccount?.number} - ${bankAccount?.verificationNumber ?? ''}`}
        </Descriptions.Item>
      </Descriptions>
    </ContentWrapper>
  );
}
